import { Observable } from 'rxjs';
import { ModalsService, ModulesSelectors } from '@serviceos-ng/core';
import { Router } from '@angular/router';
import { Component, OnInit, HostListener, ViewEncapsulation } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
} from 'angular-animations';
import { GdprModalComponent } from '../gdpr-modal/gdpr-modal.component';
import { GdprService } from '../gdpr.service';

@Component({
    selector: 'serviceos-web-gdpr',
    templateUrl: './gdpr.component.html',
    styleUrls: ['./gdpr.component.scss'],
    animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
    encapsulation: ViewEncapsulation.None
})
export class GdprComponent implements OnInit {
    showGDPR = true;

    @Select(ModulesSelectors.getComponentFromModule('customer', 'gdpr'))
    gdprConfig$!: Observable<any>;

    @HostListener('click', ['$event.target'])
    clickedAction(eventTarget: HTMLElement) {
        const action = eventTarget.getAttribute('data-action') || eventTarget.getAttribute('action');
        if (action) {
            switch (action) {
                case 'cookie-policy':
                    this.cookiePolicy();
                    break;
                case 'tracking-preferences':
                    this.trackingPreferences();
                    break;
            }
        }
    }

    constructor(
        private store: Store,
        private router: Router,
        private modalsService: ModalsService,
        private gdprService: GdprService
    ) {}

    ngOnInit(): void {
        this.showGDPR = this.gdprService.shouldShowGDPR();
    }

    hide() {
        this.showGDPR = false;
        this.gdprService.setGDPRPreferences({
            performanceCookies: true,
            functionalCookies: true,
            targetingCookies: true,
        });
    }

    cookiePolicy() {
        const cookiePolicyUrl = this.store.selectSnapshot(
            ModulesSelectors.getSetting('cookie_policy_url')
        );

        window.location.href = cookiePolicyUrl;
        // this.router.navigateByUrl(cookiePolicyUrl);
    }

    trackingPreferences() {
        this.modalsService.open(GdprModalComponent, {
            backdropClickClose: true,
        });
    }
}
